import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';
import { useI18n } from 'core/i18n/I18nProvider';

export function useUnsavedChanges(isDirty) {
  const { t } = useI18n();
  const blocker = useBlocker(Boolean(isDirty));

  useEffect(() => {
    const onBeforeUnload = (event) => {
      if (!isDirty) {
        return;
      }
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, [isDirty]);

  useEffect(() => {
    if (blocker.state !== 'blocked') {
      return;
    }
    if (!isDirty) {
      blocker.proceed();
      return;
    }
    const confirmed = window.confirm(t('confirm.leaveUnsaved'));
    if (confirmed) {
      blocker.proceed();
    } else {
      blocker.reset();
    }
  }, [blocker, isDirty, t]);
}
